/**
 * Get the fancy date format.
 *
 * @returns A fancy date format.
 */
export default function useFancyDateFormat() {
  return 'h[:]mm A [on] dddd, MMMM Do'
}
